import React from 'react'
import Especialidad from "../img/chef1.png"; 
import Calidad from "../img/calidad1.png"; 
import Atencion from "../img/fiesta3.png"; 

const AcercaDe = () => {
    return (
        <section
        className="w-full h-full flex flex-col items-center justify-center gap-6"
        id="galeria">
    
            <div className="py-2 pt-40 flex-1 flex flex-col justify-center gap-3">
              {/* <div className="flex items-center gap-2 justify-center bg-orange-100 px-4 py-1 rounded-full">
                <p className="text-base text-orange-500 font-semibold">
                  Servicio de Delivery
                </p>
              </div> */}
      
              <p className="text-[1.5rem] lg:text-[4.0rem] mt-5 font-bold text-headingColor content-center">
                Sabor Dulce & Fiesta
                <div className="flex space-x-1 mb-1 text-slate-400 font-normal">
                  <span className="text-orange-600 text-[2rem] text-xs-[2rem]">
                    Eventos Creativos
                  </span>
                </div>
              </p>
        
              {/* <p className="text-base text-textColor text-center md:text-left md:w-[100%] mt-5">
               Es una empresa joven de Catering, Pasteleria y Chocolateria<br/> 
               <br/>Nos especializamos en Eventos & Pasteleria<br/>
               <br/>Nuestro destacado sabor en Tortas nos caracteriza
               <br/>
               <br/>Atendemos eventos matrimoniales, cumpleaños y otros<br/>
               <br/>Hacemos que cada evento sea una experiencia memorable
              </p> */}
    
              <div className="py-2 flex-1 flex items-center relative">
              {/* lg:w-auto lg:h-350 */}
              <img
                src="https://www.clara.es/medio/2021/06/16/tartas-frias-home_5dacc310_800x467.jpg"
                className="w-96 h-96 ml-auto h-220 cursor-pointer rounded-full"
                alt="referencia"
              />
              </div>          
            </div>   
            <div className="grid sm:grid-cols-1 md:grid-cols- lg:grid-cols-3 gap-3 text-base text-textColor text-center md:text-center md:w-[60%] mt-1">              
              <div className="p-6 shadow-2xl">
              {/* https://cdn.kastatic.org/images/lohp/personalized_learning_icon.png */}
                <img
                  src={Especialidad}
                  className=" ml-auto h-220 w-full lg:w-auto lg:h-2/10 pt-5"
                  alt="referencia"
                />                
                <span className="text-2xl text-center">Especialidad</span>
                <div className="mt-4 md:text-left"><p>Tortas Personalizadas a la Medida de tus Sueños.</p>
                <p class="pt-4">Bienvenido a nuestra sección de Especialidad, donde la creatividad se encuentra con la maestría culinaria para dar vida a tortas personalizadas excepcionales. En <b>Sabor, Dulce & Fiesta</b>, nos apasiona la creación de momentos memorables a través de nuestras deliciosas y visualmente impresionantes obras maestras en repostería.</p>
                <p class="pt-4">
                Creación Personalizada: Transformamos tus Ideas en Realidad Comestible.
                </p>
                <p class="pt-4">
                En <b>Sabor, Dulce & Fiesta</b>, entendemos que cada ocasión es única y especial. Es por eso que nos especializamos en la creación de tortas personalizadas que reflejan tus gustos, personalidad y la esencia misma de la celebración. 
                </p>
                <p class="pt-4">
                Desde elegantes bodas hasta cumpleaños extravagantes y eventos corporativos, nuestro equipo de pasteleros expertos se dedica a transformar tus ideas en exquisitas creaciones comestibles.
                Variedad de Estilos y Sabores.</p>
                </div>
              </div>
              <div className="p-6 shadow-2xl">
              {/* https://cdn.kastatic.org/images/lohp/trusted_content_icon.png */}
                <img
                  src={Calidad}
                  className=" ml-auto h-220 w-full lg:w-auto lg:h-350"
                  alt="referencia"
                />                
                <span className="text-2xl text-center">Calidad</span>
                <div className="mt-4">
    <p>En <b>Sabor, Dulce & Fiesta</b>, la calidad es el pilar fundamental que impulsa cada aspecto de nuestro servicio, desde la selección de ingredientes hasta la ejecución de eventos impecables. Nos enorgullece ser artífices de momentos inolvidables, y esa dedicación se refleja en la excelencia de nuestras tortas personalizadas y servicios de planificación de eventos.</p>

   <p class="pt-4"><strong>Ingredientes de la Más Alta Calidad: El Arte Comienza con la Materia Prima.</strong></p>

    <p class="pt-4">Cada torta que creamos es una obra maestra culinaria, y para alcanzar ese estándar, utilizamos solo ingredientes de la más alta calidad. Desde la mantequilla hasta las frutas frescas y los chocolates selectos, cada componente se elige cuidadosamente para garantizar un sabor excepcional en cada bocado. <p class="pt-4">Nos esforzamos por superar las expectativas de nuestros clientes.</p></p>
    
    <p class="pt-4"><strong>Planificación de Eventos sin Compromisos: Detalles que Hacen la Diferencia.</strong></p>

    <p class="pt-4">En la planificación de eventos, la calidad se encuentra en los detalles. <p class="pt-4">Nuestro equipo de coordinadores de eventos está comprometido con la ejecución impecable de cada celebración. Desde la selección de la ubicación hasta la disposición de la decoración, cada aspecto se maneja con precisión y atención meticulosa.</p> 
    <p class="pt-4"> Nos aseguramos de que cada evento refleje la visión única de nuestros clientes y deje una impresión duradera.</p>
    </p>
</div>

              </div>
              <div className="p-6 shadow-2xl">
              {/* https://cdn.kastatic.org/images/lohp/empower_teachers_icon.png */}
              <img
                  src={Atencion}
                  className=" ml-auto h-220 w-full lg:w-auto lg:h-2/8"
                  alt="referencia"
                />                
                <span className="text-2xl text-center">Atencion</span>                
                <div className="mt-4"><p class="pt-4">Nos especializamos en la organización de eventos matrimoniales, celebraciones de cumpleaños y una amplia variedad de ocasiones especiales.</p>
                <p class="pt-4">Atención Personalizada: <strong>¡Transformando tus Sueños en Realidad!</strong>.</p>
                <p class="pt-4">
En <b>Sabor, Dulce & Fiesta</b>, nuestra atención no es solo un servicio; es un compromiso personal con cada cliente y cada celebración. Estamos dedicados a brindar una experiencia única, centrada en tus necesidades y deseos. Ya sea que estés planificando una boda mágica, un cumpleaños especial o cualquier otro evento significativo, nuestro equipo está aquí para hacer que cada momento sea inolvidable.</p>
<p class="pt-4">
Asesoramiento Experto: Tu Visión, nuestra guía
en el corazón de nuestro servicio de atención está el deseo de comprender y dar vida a tus ideas. 
</p>
<p class="pt-4">
<strong>Flexibilidad y Adaptabilidad: Nos Ajustamos a tus Necesidades.</strong>
</p>
<p class="pt-4">
Entendemos que cada cliente es único y que cada celebración tiene sus propias particularidades. Nos enorgullece ser flexibles y adaptables para satisfacer tus necesidades específicas. 
</p>
<p class="pt-4">
Mantenemos actualizados a nuestros clientes.
En <b>Sabor, Dulce & Fiesta</b>, creemos en la importancia de una comunicación clara y transparente.</p> 
<p class="pt-4">
Mantenemos a nuestros clientes informados en cada etapa del proceso, desde la planificación inicial hasta la entrega final. Nuestra meta es superar tus expectativas y dejar una impresión duradera, construyendo relaciones a largo plazo basadas en la confianza y la satisfacción del cliente.
</p>
                </div>
              </div>
           </div>                 
        </section>
      );
}

export default AcercaDe